import React, { FC } from 'react'
import cx from 'classnames'
import { ITooltip } from 'react-tooltip'

import * as SC from './styled'

export type LexiconTooltipProps = ITooltip & {
  className?: string
  content?: string | React.ReactNode
  color?: string
}

const LexiconTooltip: FC<LexiconTooltipProps> = ({
  className,
  content,
  color,
  ...tooltipProps
}) => {
  return (
    <SC.Container
      className={cx('LexiconTooltip', className)}
      // default
      positionStrategy="fixed"
      openEvents={{ mouseenter: true, focus: true }}
      closeEvents={{ mouseleave: true, blur: true }}
      globalCloseEvents={{ escape: true, clickOutsideAnchor: true }}
      // override
      {...tooltipProps}
      // customStuff
      $color={color}
    >
      {content}
    </SC.Container>
  )
}

export default LexiconTooltip
